import styled from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const JanelaAjuda = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  // width: 80%;
  // max-width: 640px;
  // comentado acima e adicionado duas linhas abaixo para controlar melhor dinamicamente a largura do modal e nao ficar quebrando sem necessidade as palavras
  min-width: 650px;
  max-width: 80vw;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  iframe {
    max-width: 100%;
    max-height: 80vh;
  }

  img {
    object-fit: contain;
    overflow: hidden;
    max-height: 75vh;
  }
`;

export const TituloAjuda = styled.h4`
    font-size: 1.2em;
    margin-top: 0;
    color: #828282;
`;

export const Ajuda = styled.span`
  background-color: #f2f2f2;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #ddd;
  padding: ${espacamento.pequeno}px;
  white-space: pre-wrap;
`;
